import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const namespaced = true

const defaultMeta =  {
  current_page: 1,
  desc: true,
  last_page: null,
  order: 'sent',
  per_page: null,
  search: null,
  total: null
}

const _defaultView = 'unread'
const _readView = 'read'

const state = {
  current: null,
  _defaultView,
  _readView,
  views: {
    [_defaultView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        active: true,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_readView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        active: false,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/suggestions/index.js